import WithAuth from "../../hoc/withAuth";
import { Container } from "./styles";
import { Tabs } from "antd";
import { Button, Flex, Text, Tooltip } from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import { useTransfer } from "../../hooks/useTransfer";
import { Filter } from "../../components/Filter";
import { formatCurrency, showToast, useUserInfo } from "../../utils";
import { Approval } from "./approval";
import { Alert } from "../../components/Alert";
import { LastApproved } from "./lastApproval";
import { ToDo } from "./toDo";

export interface transferBatch {
    uuidTransferBatch: string;
    sellerName: string;
    pixKey: string;
    createDate: string;
    amount: number;
}

export interface toDoTransferData {
    accountId: string;
    sellerName: string;
    pixKey: string;
    amount: number;
    sellerAccountancy?: {
        id: string;
        accountId: string;
        sellerName: string;
        pixKey: string;
    }
}

interface transferBatchData {
    totalAmount: number;
    totalItens: number;
}

interface SellerTransferProcess {
    transferredAt?: string,
    status?: string,
}

export interface lastApprovedData {
    sellerName: string;
    accountId: number;
    pixKey: string;
    status: string;
    approvedDate: string;
    processDate: string;
    amount: number;
    transferProcess: Array<SellerTransferProcess> | Array<null>;
}

function Repasses() {
    const [actualKey, setActualKey] = useState<string>();
    const [toDoTransfers, setToDoTransfers] = useState([]);
    const [authorizeTransfers, setAuthorizeTransfers] = useState<Array<transferBatch>>([] as Array<transferBatch>);
    const [transferBatchData, setTransferBatchData] = useState<transferBatchData>({} as transferBatchData);
    const [lastApprovedData, setLastApprovedData] = useState<Array<lastApprovedData>>([] as Array<lastApprovedData>);
    const [barteBalance, setBarteBalance] = useState<number>(0);
    const [transferBatchModalState, setTransferBatchModalState] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState(false);
    const { roles } = useUserInfo();
    const { 
        getToDoTransfers, 
        getToAuthorize, 
        getBarteBalance, 
        getLastApproved, 
        authorizeBatch 
    } = useTransfer();
    let aprovalBatchButtonState = (roles?.includes("BARTE_TRANSFER_AUTHORIZATION") && (transferBatchData?.totalAmount >= barteBalance));
    const ref = useRef();
    const tabs = [
        {
            tab: "A fazer",
            key: "FAZ",
            status: "FAZ"
        },
        {
            tab: "Aprovação",
            key: "APP",
            status: "APP"
        },
        {
            tab: "Últimos finalizados",
            key: "FIN",
            status: "FIN"
        }
    ];
    const { TabPane } = Tabs;
    async function handleCompleteTransfer() {
        try {
            setIsLoading(true);
            const authorizeTransfersUuidArray = authorizeTransfers.map(item => item.uuidTransferBatch);
            await authorizeBatch({"transferBatchUuid": authorizeTransfersUuidArray });
            showToast(({
                type: "success",
                message: "Repasses confirmados com sucesso"
            }));
            setAuthorizeTransfers([]);
            setTransferBatchData({
                totalAmount: 0,
                totalItens: 0
            })  
        } catch (error) {
          error?.response?.data?.errors?.map((error:any) => (
            showToast({
                type: "error",
                message: `${error?.code} - ${error?.description}`
            })
          ));
        } finally {
            setIsLoading(false);
            setTransferBatchModalState(!transferBatchModalState);
        }
    }
    async function getInitialData(searchParam?: string) {
        try {
            const response = await getToDoTransfers(searchParam ? { companyName: searchParam ?? ""} : {}, { size: 10000});
            setToDoTransfers(response?.data?.content);
            const authorizeResponse = await getToAuthorize(searchParam ? { companyName: searchParam ?? ""} : {}, { size: 10000});
            setAuthorizeTransfers(authorizeResponse?.data?.content);
            const barteBalanceResponse = await getBarteBalance();
            setBarteBalance(barteBalanceResponse?.data.balance);
            const lastApproved = await getLastApproved(searchParam ? { companyName: searchParam ?? ""} : {}, { size: 10000});
            setLastApprovedData(lastApproved?.data);
            const totalTransferBatchAmount = authorizeResponse?.data?.content.reduce((acc: any, nextValue: any) =>
                acc + nextValue.amount
                , 0);
            const totalTransferBatchItens = authorizeResponse?.data?.content?.length;
            setTransferBatchData({
                totalAmount: totalTransferBatchAmount,
                totalItens: totalTransferBatchItens
            })   
        } catch {
        } finally {
        }
    }
    useEffect(() => {
        getInitialData();
        // eslint-disable-next-line
    }, []);
    return (
        <>
            <Alert
                isOpen={transferBatchModalState}
                onClose={() => setTransferBatchModalState(!transferBatchModalState)}
                title="Confirmar aprovação dos repasses?"
                messageBody="Deseja confirmar a aprovação de todos os repasses dessa listagem?"
                confirmButtonText="Confirmar"
                closeButtonText="Cancelar"
                onConfirm={handleCompleteTransfer}
                leastDestructiveRef={ref}
            />
            <Container>

                <h1>Repasses</h1>
                {actualKey === "APP" && (
                    <Flex position="absolute" flexDir="column" right="78px" top="10px" zIndex="10">
                        <Flex
                            position="absolute"
                            right="0"
                            top="80px"
                            height="32px"
                            minWidth="275px"
                            fontSize="14px"
                            borderRadius="none"
                            bgColor="#FBFCFE"
                            border="1px solid #E6E9F0"
                            color="#3D485C"
                            fontWeight="400"
                            align="center"
                            justify="center"
                        >
                            Saldo Barte: {formatCurrency({ value: barteBalance })}
                        </Flex>
                        <Tooltip
                            label="Não há saldo suficiente para realizar os repasses"
                            aria-label="A tooltip"
                            isDisabled={!aprovalBatchButtonState}
                            hasArrow
                        >
                            <span style={{ position: "absolute", right: "0", top: "130px" }} >
                                <Button
                                    height="32px"
                                    minWidth="275px"
                                    fontSize="14px"
                                    borderRadius="2px"
                                    fontWeight="400"
                                    color={aprovalBatchButtonState ? "#00000080" : "#FFF"}
                                    border={aprovalBatchButtonState ? "1px solid #D9D9D9" : ""}
                                    bgColor={aprovalBatchButtonState ? "#F5F5F5" : "#1890FF"}
                                    disabled={aprovalBatchButtonState || transferBatchData?.totalAmount === 0 || authorizeTransfers?.length === 0 || isLoading }
                                    isLoading={isLoading}
                                    onClick={() => setTransferBatchModalState(!transferBatchModalState)}

                                >
                                    Aprovar
                                    <Text fontWeight="700" margin="0 3px">{transferBatchData?.totalItens}</Text>
                                    repasses |
                                    <Text fontWeight="700" margin="0 3px">{formatCurrency({ value: transferBatchData?.totalAmount ?? 0 })}</Text>
                                </Button>
                            </span>
                        </Tooltip>
                    </Flex>
                )}
                <Tabs
                    defaultActiveKey={actualKey}
                    className="tabs-custom"
                    onChange={setActualKey}
                >
                    {tabs.map(({ key, tab }) => (
                        <TabPane tab={tab} key={key}>
                            <Filter
                                placeholder="Buscar seller"
                                needToSubmit
                                onSubmitSearch={getInitialData}
                            />
                            {key === "FAZ" && (
                                <ToDo 
                                    ref={ref} 
                                    toDoTransfers={toDoTransfers}
                                />
                            )}
                            {key === "APP" && (
                                <Approval 
                                    ref={ref} 
                                    authorizeTransfers={authorizeTransfers} 
                                />
                            )}
                            {key === "FIN" && (
                                <LastApproved 
                                    ref={ref} 
                                    lastApprovedData={lastApprovedData}
                                />
                            )}
                        </TabPane>
                    ))}
                </Tabs>
            </Container>
        </>
    )
}


export default WithAuth(Repasses);